import React from 'react'
import './form-btn.scss'

const FormBtn = ({ onClick }) => {
  return <button onClick={onClick} className="form-btn">Получить результаты</button>
}

export default FormBtn
